<template>
  <div class="insights-ia-loading-state" aria-label="Carregando insights">
    <el-skeleton loading animated>
      <template #template>
        <el-row :gutter="12">
          <el-col :span="24">
            <el-skeleton-item
              variant="rect"
              class="insights-ia-loading-state__row"
              :style="{ height: '60px', marginBottom: '10px' }"
            />
          </el-col>
          <el-col :span="24">
            <el-skeleton-item
              variant="rect"
              class="insights-ia-loading-state__row"
              :style="{ height: '30px', marginBottom: '0px', width: '100%' }"
            />
            <el-skeleton-item
              variant="rect"
              class="insights-ia-loading-state__row"
              :style="{ height: '60px', marginBottom: '0', width: '100%' }"
            />
            <el-skeleton-item
              variant="rect"
              class="insights-ia-loading-state__row"
              :style="{ height: '30px', marginBottom: '10px', width: '100%' }"
            />
          </el-col>
          <el-col :span="12">
            <el-skeleton-item
              variant="rect"
              class="insights-ia-loading-state__row"
              :style="{ height: '30px', marginBottom: '0px', width: '100%' }"
            />
            <el-skeleton-item
              variant="rect"
              class="insights-ia-loading-state__row"
              :style="{ height: '60px', marginBottom: '0', width: '100%' }"
            />
            <el-skeleton-item
              variant="rect"
              class="insights-ia-loading-state__row"
              :style="{ height: '15px', marginBottom: '0', width: '100%' }"
            />
          </el-col>
          <el-col :span="12">
            <el-skeleton-item
              variant="rect"
              class="insights-ia-loading-state__row"
              :style="{ height: '30px', marginBottom: '0px', width: '100%' }"
            />
            <el-skeleton-item
              variant="rect"
              class="insights-ia-loading-state__row"
              :style="{ height: '60px', marginBottom: '0', width: '100%' }"
            />
            <el-skeleton-item
              variant="rect"
              class="insights-ia-loading-state__row"
              :style="{ height: '15px', marginBottom: '0', width: '100%' }"
            />
          </el-col>
        </el-row>
      </template>
    </el-skeleton>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    rows?: number;
  }>(),
  {
    rows: 6
  }
);
</script>

<style scoped lang="scss">
.insights-ia-loading-state {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: auto;
}
</style>
